import { render, staticRenderFns } from "./ViewAcademyReview.vue?vue&type=template&id=5efa80e1&scoped=true"
import script from "./ViewAcademyReview.vue?vue&type=script&lang=js"
export * from "./ViewAcademyReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa80e1",
  null
  
)

export default component.exports